/**
 * @ngdoc directive
 * @name Classifications Dropdown
 *
 * @description
   Shows typeahead selector for choosing tabulate journal account
 *
 * @scope
 * @param {Object} classificationParent - object which has classification field as property (classofocationParent = { classificationField: {} })
 * @param {String} classificationField - name of classification field in classificationParent
 * @param {Array} classifications - array of tabulate journal accounts
 * @param {Function} afterChange - callback on classification change
 * @param {Boolean} doNotShowMobileSelector - do not show typeahead selector on mobile on click
 *
 * @example
    <form name='classificationsForm' ng-init='parent={}'>
    <classifications-dropdown
      classification-parent="parent"
      classifications="classifications"
      parent-form="classificationsForm"
      on-amount-change="alert"
    >
    </classification-dropdown>
    </form>
 */

(function () {
  'use strict';

  directive.$inject = ["PATH", "classificationDataService"];
  app.directive('classificationsDropdown', directive);

  function directive(PATH, classificationDataService) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        classificationParent: '=',
        classifications: '=',
        afterChange: '&',
        doNotShowMobileSelector: '=?'
      },
      templateUrl: PATH.components + 'classificationsDropdown/template.html',
      link: link
    };

    function link($scope, $element, $attributes) {
      var classificationField = $attributes.classificationField || 'classification';
      var current = $scope.classificationParent[classificationField];

      $scope.classificationField = classificationField;

      $scope.getClassifications = function () {
        var classifications = [];
        _.forEach($scope.classifications, function (classification) {
          if ((classification && !classification.tjaDisplayRule && classification.active) ||
            // eslint-disable-next-line max-len
              (classification && classification.tjaDisplayRule && classification.tjaDisplayRule.display) ||
              current && current.id === classification.id ||
              (classification && classification.groupName)) {
            classifications.push({
              id: classification.id,
              caption: classification.caption,
              tjaTypeName: classification.tjaType && classification.tjaType.name,
              groupName: classification.groupName
            });
          }
        });
        return classifications;
      };


      $scope.getByTypeOrName = function (actual, expected) {
        if (!expected) return true;

        var actualName = typeof actual === 'string' && actual;
        var expectedName = typeof expected === 'string' && expected;

        if (!actualName || !expectedName) return;

        var actualNormalized = actualName.toLowerCase();
        var expectedNormalized = expectedName.toLowerCase();
        return actualNormalized.indexOf(expectedNormalized) > -1;
      };

      $scope.setMatchOrObject = function (classificationParent) {
        var existing;
        var classification = classificationParent[classificationField];

        if (!classification) {
          classificationParent[classificationField] = {};
        } else if (typeof classification === 'string') {
          existing = _.find($scope.classifications, { caption: classification });
          classificationParent[classificationField] = existing || { caption: classification };
        }
        $scope.classificationIsValid = classificationDataService.validateItem(existing);
        $scope.afterChange();
      };

      $scope.updateClassifications = function (transactionClassifications) {
        $scope.classifications = transactionClassifications;
      };
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/classificationsDropdown/directive.js